import { acronymEnergyTypeSchema } from "@qivia/schemas-shared";
import { z } from "zod";

export const getHomeChargingEligibleVehiclesResponse = z.array(
  z.object({
    uuid: z.uuid(),
    vin: z.string(),
    energyType: acronymEnergyTypeSchema,
    registrationNumber: z.string(),
  }),
);

export type GetHomeChargingEligibleVehiclesResponse = z.infer<
  typeof getHomeChargingEligibleVehiclesResponse
>;
